var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "paginator" },
    [
      _vm.index > 0
        ? _c(
            "div",
            {
              staticClass: "arrow left",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.index -= 1
                }
              }
            },
            [_c("icon", { attrs: { type: "arrowLeft", color: "#ccc" } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.activeImages, function(item) {
        return _c(
          "div",
          {
            staticClass: "thumbnail-wrapper",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.setActive(item.index - 1)
              }
            }
          },
          [
            !_vm.isMove
              ? _c("thumbnail", {
                  class: { active: item.isActive },
                  attrs: { imageUrl: item.imageUrl }
                })
              : _vm._e()
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.index < _vm.images.length - 5
        ? _c(
            "div",
            {
              staticClass: "arrow right",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.index += 1
                }
              }
            },
            [_c("icon", { attrs: { type: "arrowRight", color: "#ccc" } })],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }